<template>
  <div :class="$style.content">
    <div :class="$style.formWrapper">
      <div :class="$style.form">
        <div :class="$style.headerBar">
          <p :class="$style.formTitle">{{ $t('signin.title') }}</p>
          <div :class="$style.languageSelector">
            <cui-language-selector />
          </div>
        </div>
        <div style="clear: both"></div>
        <a-form class="login-form" :form="form" @submit="handleSubmit" >
          <a-form-item :label="$t('signin.mobile')">
            <a-input
              id="phone"
              :placeholder="$t('signin.mobile')"
              v-decorator="['phone', {rules: [{ required: true, message: $t('signin.mobileDesc') }]}]"
              :disabled="loading"
            >
              <a-select slot="addonBefore" v-model="countryCode" >
                <a-select-option v-for="(country, code) in countries" :value="code" :key="code">{{ country[0] }} (+{{ code }})</a-select-option>
              </a-select>
              <a-icon slot="prefix" type="phone" style="color: rgba(0,0,0,.25);"/>
            </a-input>
          </a-form-item>
          <a-form-item v-if="confirmationResult" label="Code">
            <a-input
              :placeholder="$t('signin.code')"
              v-decorator="['code', {rules: [{ required: true, message: $t('signin.codeDesc') }]}]"
              ref="code"
              :disabled="loading"
            >
              <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25);"/>
            </a-input>
          </a-form-item>
          <div class="">
            <a-button type="primary" htmlType="submit"
              class="login-form-button big"
              :disabled="loading">{{ confirmationResult?$t('signin.signin'):$t('signin.getCode') }}</a-button>
          </div>
        </a-form>
      </div>
      <div :class="$style.sidebar">
        <p :class="$style.sidebarTitle">GoGame</p>
        <p :class="$style.sidebarSubTitle">January 2019</p>
        <div :class="$style.sidebarContent">
          <p>{{ $t('signin.note1') }}</p>
          <p>{{ $t('signin.note2') }}</p>
          <p>{{ $t('signin.note3') }}</p>
        </div>
        <div :class="$style.sidebarFooter">
          <span>
            <i class="icmn-location mr-3"/>
            Vinh city, VN
          </span>
        </div>
      </div>
    </div>
    <div ref="recaptchaContainer"></div>
  </div>
</template>

<script>
import CuiLanguageSelector from '@/components/LayoutComponents/Topbar/LanguageSelector'
import phoneCode from 'libphonenumber-js/metadata.mobile.json'

export default {
  components: {
    CuiLanguageSelector,
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      countryCode: '84',
      countries: phoneCode.country_calling_codes,
      loading: false,
      confirmationResult: null,
    }
  },
  methods: {
    stopLoading() {
      this.loading = false
      this.$nprogress.done()
    },
    createRecapcha() {
      this.$refs['recaptchaContainer'].innerHTML = '<div id="recaptcha"></div>'
      this.$auth.createRecapcha('recaptcha')
    },
    handleSubmit(e) {
      e.preventDefault()
      let phone = this.form.getFieldValue('phone')
      const code = this.form.getFieldValue('code')
      if ( !phone ) return
      if ( phone[0]=='0' ) phone = phone.substr(1)
      phone = `+${this.countryCode}${phone}`
      console.log({phone})
      this.loading = true
      this.$nprogress.start()
      if (phone && !code) {
        return this.$auth.loginByPhone(phone).then(confirmationResult => {
          this.confirmationResult = confirmationResult
          setTimeout(() => document.getElementById('code').focus(), 100)
        }).catch(error => {
          this.$notification['warning']({
            message: error.code,
            description: error.message,
          })
          this.createRecapcha()
        }).finally(this.stopLoading)
      }
      if (phone && code && this.confirmationResult) {
        return this.confirmationResult.confirm(code).then(e => {
          window.location.href = '/dashboard'
          this.$notification['success']({
            message: this.$t('signin.success'),
            description: this.$t('signin.welcome'),
          })
        }).catch(error => {
          this.$notification['warning']({
            message: error.code,
            description: error.message,
          })
        }).finally(this.stopLoading)
      }
    },
  },
  mounted() {
    document.getElementById('phone').focus()
    this.createRecapcha()
    // console.log(getCookie("lang"))
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
